<template>
  <div id="root" class="font-body">
    <div data-testid="homepage" id="homepage">
      <div>
        <Nav :user="$attrs.user" />
        <slot />
        <Footer :user="$attrs.user" />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav";
import Footer from "./Footer";

export default {
  components: {
    Nav,
    Footer,
  },
};
</script>

